/* eslint-disable eqeqeq */
import React, { useRef, useEffect, useState } from "react";
import { Button, Modal } from "react-materialize";
import $ from "jquery";

export default function ModalWarning({
  header,
  content,
  callbackEvent,
  timeoutMs = 10000,
  height = 250 }) {
  const [isOpen, setOpen] = useState(true);
  const [modalHeight, setModalHeight] = useState(height || "auto");
  const contentRef = useRef(null);

  useEffect(() => {
    // วัดความสูงเนื้อหาหลัง render
    if (contentRef.current) {
      const realHeight = contentRef.current.offsetHeight;
      setModalHeight(realHeight + 120 + "px");
    }
  }, [content, header]);

  if (content === "") {
    content =
      "Sorry, an error occurs.<br><br>Please contact our system administrator or try again later.";
  }
  let btns = [
    <div className="header">{header}</div>,
    <Button
      flat
      modal="close"
      node="button"
      waves="red"
      className="modal-close"
    >
      <i className="material-icons">close</i>
    </Button>,
  ];
  let timeout = "";
  const handleEvents = {
    OnComplete: function () {
      timeout = setTimeout(function () {
        $("body").css({ overflow: "auto" });
        setOpen(false);
        if ("OnClose" in callbackEvent) {
          callbackEvent.OnClose();
        }
      }, timeoutMs);
    },
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setOpen(false);
      if ("OnClose" in callbackEvent) {
        callbackEvent.OnClose();
      }
      if (timeout != "") {
        clearTimeout(timeout);
      }
    } };

  if (!isOpen) {
    return "";
  }
  return (
    <Modal
      key="modal-warning"
      actions={btns}
      bottomSheet={false}
      fixedFooter={false}
      className="modal-user"
      id="modal-warning"
      open={true}
      options={{
        dismissible: true,
        endingTop: "10%",
        inDuration: 250,
        onCloseEnd: null,
        onCloseStart: handleEvents.OnClose,
        onOpenEnd: null,
        onOpenStart: handleEvents.OnComplete,
        opacity: 0.5,
        outDuration: 250,
        preventScrolling: true,
        startingTop: "5%" }}
      root={document.getElementById("root")}
      style={{ height: modalHeight }}
    >
      <div id="modal-warning-content" ref={contentRef}>
        <i className="material-icons">warning</i>
        <div
          className="text"
          style={{ fontSize: "16px" }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </Modal>
  );
}

